import { irm_actionNotAllowedOnThisConversation } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisconversation.locstring.json';
import { itemHeaderPrint } from 'owa-locstrings/lib/strings/itemheaderprint.locstring.json';
import loc, { format } from 'owa-localize';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { ClientItemId } from 'owa-client-ids';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint } from 'owa-mail-reading-pane-store';
import { ActionSource } from 'owa-analytics-actions';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';

import { action } from 'satcheljs/lib/legacy';

export default action('printConversation')(async function printConversation(
    conversationId: ClientItemId,
    actionSource: ActionSource
) {
    const latestNonDraftItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (latestNonDraftItemId && latestNonDraftItemId.Id) {
        const restrictionToConfirm = <IRMRestrictions>{ PrintAllowed: true };
        if (
            confirmItemActionAllowed(
                latestNonDraftItemId.Id,
                restrictionToConfirm,
                format(loc(irm_actionNotAllowedOnThisConversation), loc(itemHeaderPrint))
            )
        ) {
            lazyPrint.importAndExecute(latestNonDraftItemId, actionSource);
            onPrintRow();
        }
    }
});
